import React, { useState,useEffect} from "react";
import { useOutletContext  } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, Col, Row, Button, Flex, Typography, Tag } from "antd";
import {
  RiseOutlined,
  SnippetsOutlined,
  PicCenterOutlined,
  FallOutlined
} from "@ant-design/icons";
import DashboardAPI from "../../restAPI/DashboardAPI";
const { Text } = Typography;


const DashboardStats = () => {
  const {groupId, companyId} = useOutletContext();
  const { token } = useSelector(state => state.auth);
  const [fileUploadDetails ,setFileUploadDetails] = useState({});

    useEffect(() => {
      getCardData();
    }, [groupId, companyId]);

  const getCardData =  () =>{
     DashboardAPI.getDocumentUploadDetails(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
    .then((res) => {
      if (res?.data) {
        console.log("carddetails",JSON.stringify(res.data));
        setFileUploadDetails({
            cMUploadedFileCount: res.data.uploadedDocumentsThisMonth,
            lMUploadedFileCount: res.data.uploadedlDocumentsLastMonth,
            cmUploadedFilePercentage :res.data.uploadComparison,
            IsUploadPercentage:parseInt(res.data.uploadComparison) > 0,
            incCMUploadedFileCount:res.data.incompleteDocumentsThisMonth,
            incLMUploadedFileCount:res.data.incompleteDocumentsLastMonth,
            allIncDocumentCount:res.data.allIncDocumentCount,
            inccmUploadedFilePercentage: res.data.incompleteComparison,
            IsIncompletePercentage:parseInt(res.data.incompleteComparison) > 0,
        });
      }
    })
    .catch((err) => {
      console.log("error getting user data :", err.message);
    });
  }

  return (
    <Row gutter={16} className="">
      <Col
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="border-container">
          <Button
            type="default"
            variant="dashed"
            className="card-button inactive-b"
            size="large"
            icon={<SnippetsOutlined />}
            shape="circle"
          />
          <Card className="document-card">
            <Flex
              vertical
              justify="space-between"
              align="flex-start"
              style={{ height: "100%", height: "180px" }}
            >
              <div className="title">
              Total Documents Uploaded<br/>This Month
              </div>
              <Flex vertical align="flex-start">
                <div className="count">{fileUploadDetails.cMUploadedFileCount}</div>

                <Flex justify="flex-start" align="center" gap={12}>
                  <Tag color= {fileUploadDetails.IsUploadPercentage ? "success" : "error"} bordered={false} icon={fileUploadDetails.IsUploadPercentage? <RiseOutlined /> :<FallOutlined/>}>
                    {fileUploadDetails.cmUploadedFilePercentage}
                  </Tag>
                  <Text>Than last month</Text>
                </Flex>
              </Flex>
            </Flex>
          </Card>
        </div>
      </Col>

      <Col
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="border-container">
          <Button
            type="default"
            variant="dashed"
            className="card-button inactive-b"
            size="large"
            icon={<PicCenterOutlined />}
            shape="circle"
          />

          <Card className="document-card">
            <Flex
              vertical
              justify="space-between"
              align="flex-start"
              style={{ height: "100%", height: "180px" }}
            >
              <div className="title">
                Incomplete
                Documents

              </div>
              <Flex vertical align="flex-start">
                <div className="count">{fileUploadDetails.incCMUploadedFileCount}</div>

                <Flex justify="flex-start" align="center" gap={12}>
                  <Tag color={fileUploadDetails.IsIncompletePercentage? "error": "success" } bordered={false} icon={fileUploadDetails.IsIncompletePercentage ?  <RiseOutlined />:<FallOutlined/>}>
                  {fileUploadDetails.inccmUploadedFilePercentage}
                  </Tag>
                  <Text>Than last month</Text>
                </Flex>
              </Flex>
            </Flex>
          </Card>
        </div>
      </Col>



    </Row>
  );
};

export default DashboardStats;
